export default {
  backgrounds: [
    { className: "primary-bg-colour", colour: "#E31E24" },      // Sports Hub Red
    { className: "secondary-bg-colour", colour: "#1A1A1A" },    // Dark
    { className: "tertiary-bg-colour", colour: "#F8F9FA" },     // Light
    { className: "inactive-bg-colour", colour: "#cccccc" },     // Inactive
    { className: "misc-bg-colour", colour: "#f0f0f0" },         // Misc
    { className: "cricket-bg-colour", colour: "#003C71" },      // Cricket Blue
    { className: "rugby-bg-colour", colour: "#006747" },        // Rugby Green
    { className: "soccer-bg-colour", colour: "#E31E24" },       // Soccer Red
    { className: "motorsport-bg-colour", colour: "#E10600" },   // Motorsport Red
  ],
  text: [
    { className: "primary-text", colour: "#ffffff" },           // White
    { className: "secondary-text", colour: "#1A1A1A" },         // Dark
    { className: "tertiary-text", colour: "#6C757D" },          // Gray
    { className: "misc-text", colour: "#E31E24" },              // Brand Red
  ],
  borders: [
    { className: "primary-border-colour", colour: "#E31E24" },
    { className: "secondary-border-colour", colour: "#1A1A1A" },
    { className: "primary-free-border-colour", colour: "#6C757D" },
  ]
}
